import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {AgentScheduleImportRow} from "../../../components/agent-schedule-import-view/agent-schedule-import-view.component";
import {ScheduleType} from "../../../../schedule/types/schedule.type";
import {
  AGENT_SCHEDULE_IMPORT_TABLE_COLUMN_WIDTHS,
  AGENT_SCHEDULE_IMPORT_TABLE_ROW_HEIGHT,
  AGENT_SCHEDULE_IMPORT_TABLE_UNIQUE_ID,
  AgentScheduleColumns,
  NO_ERRORS_EMPTY_STATE_TEXT,
  NO_MATCHING_TYPES_EMPTY_STATE_TEXT
} from "./agent-schedule-import-table.constant";

require('./agent-schedule-import-table.scss');
@Component({
  standalone: false,
  selector: 'app-agent-schedule-import-table',
  templateUrl: './agent-schedule-import-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentScheduleImportTableComponent implements OnChanges {

  @Input() items: AgentScheduleImportRow[] = [];
  @Input() columns: AgentScheduleColumns = {};
  @Output() onRemoveRow = new EventEmitter<AgentScheduleImportRow>();
  @Output() onOpenColumnSettings = new EventEmitter<Event>();

  public readonly tableUniqueId: string = AGENT_SCHEDULE_IMPORT_TABLE_UNIQUE_ID;
  public readonly defaultWidths: { [key: string]: number } = AGENT_SCHEDULE_IMPORT_TABLE_COLUMN_WIDTHS;
  public readonly rowHeight: number = AGENT_SCHEDULE_IMPORT_TABLE_ROW_HEIGHT;
  public readonly typeOptions: string[] = Object.values(ScheduleType);

  public selectedTypes: string[] = [];
  public filteredItems: AgentScheduleImportRow[] = [];
  public emptyStateText: string = NO_ERRORS_EMPTY_STATE_TEXT;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items) {
      this._applyTypeFilter();
    }
  }

  onTypeFilterChange(types: string[]) {
    this.selectedTypes = types || [];
    this._applyTypeFilter();
  }

  private _applyTypeFilter() {
    this.filteredItems = this.selectedTypes.length
      ? this.items.filter((item) => this.selectedTypes.includes(item.rawRow?.type))
      : this.items;
    this.emptyStateText = this.selectedTypes.length ? NO_MATCHING_TYPES_EMPTY_STATE_TEXT : NO_ERRORS_EMPTY_STATE_TEXT;
  }
}
